export const CourseDetailsLink = (id) => {
    return `/courseAdministration/coursesdetails/${id}/dashboard/show`;
}

export const StudentDetailsLink = (id) => {
    return `/studentAdministration/students/open/${id}/general`;
}